'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _notification = require('bender-url!../../audio/notification.mp3');

Object.defineProperty(exports, 'notification', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_notification).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }